<template>
  <div class="canvas-controls">
    <div class="buttons">
      <button
        class="btn btn-secondary"
        @click="turn"
      >
        <i class="fa fa-sync" />
      </button>
      <button
        class="btn btn-secondary"
        @click="reset"
      >
        <i class="fa fa-expand" />
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AssemblyInspectorControls',
  props: {
  },
  data() {
    return {
      bus: this.$root.bus,
    };
  },
  computed: {
  },
  mounted() {
  },
  methods: {
    turn() {
      this.bus.emit('changePerspective', 'turn');
    },
    reset() {
      this.bus.emit('changePerspective', 'front');
    },
  },
};
</script>

<style scoped lang="scss">
.canvas-controls {
  position: absolute;
  top: 0px;
  margin-top: 1.5rem;
  margin-left: 1.5rem;
}

.buttons {
  button {
    margin: 0 2px;
  }
}
</style>
